// extracted by mini-css-extract-plugin
module.exports = {"notes":"FinePrintInfoCard_notes__33sfU","notesText":"FinePrintInfoCard_notesText__2pebk","defaultFinePrintText":"FinePrintInfoCard_defaultFinePrintText__1b-y7"};